import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Button, IconButton, List, ListItem, ListItemButton, ListItemSecondaryAction, ListItemText } from "@mui/material";
import _, { isNumber } from "lodash";
import { DateTime } from "luxon";
import { useState } from "react";
import { ModalComponent } from "../../../components/Modal/ModalComponent";
import { ClimbingEventGroup } from "../../../models/ClimbingEvent";
import { rangeToString, toDate } from "../../../services/time/TimeService";
import { EditGroup } from "./EdditGroup";

type Props = {
    handleUpdateGroup: (groups: ClimbingEventGroup[]) => void,
    groups: ClimbingEventGroup[],
}
export const AddingGroups: React.FC<Props> = ({ handleUpdateGroup, groups }) => {
    const [selectedGroup, setSelectedGroup] = useState<ClimbingEventGroup | null>(null)

    const createNewId = (): number => {
        const id = _.maxBy(groups, (g) => g.id)?.id
        return isNumber(id) ? id + 1 : 1
    }


    const handleUpdate = (group: ClimbingEventGroup) => {
        const indexToUpdate = groups.findIndex(g => g.id === group.id)
        if (indexToUpdate !== -1) {
            groups[indexToUpdate] = group
        } else {
            groups.push(group)
        }
        setSelectedGroup(null)
        handleUpdateGroup(groups)
    }


    return <Box>
        <List>
            {groups.map((group, index) => (
                <ListItem key={"group_" + index}>
                    <ListItemButton onClick={()=>setSelectedGroup(group)}>
                        <ListItemText primary={group.name} secondary={rangeToString(toDate(group.startDate), toDate(group.endDate))} />
                    </ListItemButton>
                    <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="delete" onClick={() => handleUpdateGroup(groups.filter((_, i) => i !== index))}>
                            <DeleteIcon />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
            ))}
        </List>
        <Button onClick={(click) => {
            setSelectedGroup({ id: createNewId(), name: "", startDate: DateTime.now().toMillis(), endDate: DateTime.now().toMillis() })
            handleUpdateGroup(groups)
        }}> Dodaj grupę</Button>
        {selectedGroup && <ModalComponent open={true} onClose={() => setSelectedGroup(null)} childComp={<EditGroup group={selectedGroup} handleUpdateGroup={handleUpdate} />} />
    }
       
    </Box>
}

